import { LanguagesComponent } from './../../_directives/languages.component';
import {
  DropdownSelectTranslate,
  UserDropdownSelectTranslate
} from './../../_helpers/pipes';
import { BusinessServices } from './../businesses/services/business.services';
import { ActivityServices } from '../follow-ups/services/activities.services';
import { FeaturesComponent } from './../features/components/features.component';
import { staticdataComponent } from './../follow-ups/components/staticdata.component';
import { WidgetsModule } from './widgets.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { BlurDirective } from '../../shared/directives/blur.directive';
import { BlurService } from '../../shared/services/blur.service';
import { ConfirmationService } from 'primeng/api';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import {
  StatusPipe,
  MonthPipe,
  LicenseCategoryPipe,
  AssignValuePipe,
  RowStatusPipe,
  categoryNamePipe,
  CapitalizePipe,
  FormatHoursPipe,
  RolesPipe,
  ModulesPipe,
  FormatTimePipe,
  SearchPipe,
  SicknessReasonTranslate,
  moduleNamePipe,
  SpecifiCharPipe,
  TruncatePipe
} from '../../_helpers/pipes';
import { EditorModule } from 'primeng/editor';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from 'primeng/api';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TabsModule } from 'primeng/tabs';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TextareaModule } from 'primeng/textarea';
import { InputMaskModule } from 'primeng/inputmask';
import { ListboxModule } from 'primeng/listbox';
import { FileUploadModule } from 'primeng/fileupload';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { TreeTableModule } from 'primeng/treetable';
import { ChartModule } from 'primeng/chart';
import { ToolbarModule } from 'primeng/toolbar';
import { AccordionModule } from 'primeng/accordion';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TreeModule } from 'primeng/tree';
import { ExportProgressDialogComponent } from './components/export-progress-dialog.component';
import { BusinessSelectionDialogComponent } from './components/business-selection-dialog/business-selection-dialog.component';
import { ProgressLoaderComponent } from './components/progress-loader/progress-loader.component';
import { KubaBusyComponent } from './components/busy/busy.component';
import { EcplDocumentTreeModule } from '../../shared/ecpl-document-tree/ecpl-document-tree.module';
import { NgxUploaderCompatModule } from '../../_services/primeng-uploader';

@NgModule({
  imports: [
    TranslatePipe, TranslateDirective,
    CommonModule,
    EditorModule,
    AutoCompleteModule,
    InputTextModule,
    TextareaModule,
    InputMaskModule,
    SelectModule,
    TableModule,
    ButtonModule,
    SharedModule,
    DatePickerModule,
    FormsModule,
    ListboxModule,
    FileUploadModule,
    ReactiveFormsModule,
    CheckboxModule,
    RadioButtonModule,
    DialogModule,
    MultiSelectModule,
    TreeTableModule,
    ChartModule,
    CheckboxModule,
    TooltipModule,
    ToolbarModule,
    AccordionModule,
    NgxUploaderCompatModule,
    ProgressBarModule,
    TreeModule,
    EcplDocumentTreeModule,
    WidgetsModule,
    KubaBusyComponent
  ],
  exports: [
    TranslatePipe, TranslateDirective,
    CommonModule,
    EditorModule,
    AutoCompleteModule,
    InputTextModule,
    TextareaModule,
    InputMaskModule,
    SelectModule,
    TabsModule,
    TableModule,
    MultiSelectModule,
    CheckboxModule,
    RadioButtonModule,
    ButtonModule,
    SharedModule,
    ListboxModule,
    DatePickerModule,
    FormsModule,
    FileUploadModule,
    ReactiveFormsModule,
    staticdataComponent,
    FeaturesComponent,
    ConfirmDialogModule,
    CheckboxModule,
    DialogModule,
    TreeTableModule,
    StatusPipe,
    MonthPipe,
    LicenseCategoryPipe,
    AssignValuePipe,
    RowStatusPipe,
    categoryNamePipe,
    CapitalizePipe,
    FormatHoursPipe,
    RolesPipe,
    ModulesPipe,
    FormatTimePipe,
    ChartModule,
    CheckboxModule,
    TooltipModule,
    ToolbarModule,
    AccordionModule,
    NgxUploaderCompatModule,
    BusinessSelectionDialogComponent,
    ProgressBarModule,
    EcplDocumentTreeModule,
    WidgetsModule,
    SearchPipe,
    InputNumberModule,
    DropdownSelectTranslate,
    SicknessReasonTranslate,
    UserDropdownSelectTranslate,
    LanguagesComponent,
    moduleNamePipe,
    TruncatePipe,
    SpecifiCharPipe,
    ExportProgressDialogComponent,
    BlurDirective,
    ProgressLoaderComponent,
    KubaBusyComponent
  ],

  declarations: [
    FeaturesComponent,
    staticdataComponent,
    BusinessSelectionDialogComponent,
    StatusPipe,
    MonthPipe,
    LicenseCategoryPipe,
    AssignValuePipe,
    RowStatusPipe,
    categoryNamePipe,
    CapitalizePipe,
    RolesPipe,
    ModulesPipe,
    FormatTimePipe,
    SearchPipe,
    LanguagesComponent,
    FormatHoursPipe,
    DropdownSelectTranslate,
    SicknessReasonTranslate,
    UserDropdownSelectTranslate,
    moduleNamePipe,
    TruncatePipe,
    SpecifiCharPipe,
    ExportProgressDialogComponent,
    BlurDirective,
    ProgressLoaderComponent
  ],
  providers: [BusinessServices, ActivityServices, BlurService, ConfirmationService]
})
export class AppSharedModule {}
